import { useMemo } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { resources } from '@constants/hardcoded-strings';
import { PrefilledAttributeValidationErrors } from '@idw-types/common/prefilled-attribute-validation-errors';
import { FormattedRpServiceConfigurationAttributeWithFields } from '@idw-types/data/rp-service-configuration';
import styles from './self-service-prefilled-attributes.less';
import { AxnAttributeTypeField } from '@idw-types/data/reference-data/axn';
import { isStringTrue } from '@iddataweb/idw-common-ui/utils';
import { SelfServicePrefilledAttributeTypeField } from '@containers/common/self-service-prefilled-attributes/self-service-prefilled-attribute-type-field/self-service-prefilled-attribute-type-field';
import { SelfServicePrefilledAttributeAxnuiComponent } from '@containers/common/self-service-prefilled-attributes/self-service-prefilled-attribute-axnui-component/self-service-prefilled-attribute-axnui-component';

type SelfServicePrefilledAttributesProps = {
    requestInProgress: boolean;
    attributeTypeToFieldValueMap: { [key: string]: { [key: string]: string } };
    attributeTypesWithFields: Array<FormattedRpServiceConfigurationAttributeWithFields>;
    validationErrors: PrefilledAttributeValidationErrors;
    onAttributeFieldChange: (changeObject: { [key: string]: { [key: string]: string } }) => void;
};

export const SelfServicePrefilledAttributes = (props: SelfServicePrefilledAttributesProps) => {

    const {
        attributeTypeToFieldValueMap,
        attributeTypesWithFields,
        requestInProgress,
        validationErrors,
        onAttributeFieldChange
    } = props;

    const hasAtLeastOneRequiredField = useMemo(() => {
        return attributeTypesWithFields.some(attr => isStringTrue(attr.requiredForSelfServiceVerification));
    }, [attributeTypesWithFields]);

    const handleAttributeFieldChange = (attributeField: AxnAttributeTypeField, newValue: string) => {
        onAttributeFieldChange({
            [attributeField.attributeTypeID]: {
                ...attributeTypeToFieldValueMap[attributeField.attributeTypeID],
                [attributeField.id]: newValue
            }
        });
    };

    return (
        <Accordion defaultActiveKey={hasAtLeastOneRequiredField ? "0" : null}>
            <Accordion.Item eventKey="0">
                <Accordion.Header>{resources.modals.verificationLinkProvider.inputs.prefilledAttributes.title}</Accordion.Header>
                <Accordion.Body>

                    {attributeTypesWithFields.map((attributeType, index) => (
                        <div key={index} className={styles.prefilledAttributes}>
                            <div className={styles.formBlock}>
                                {attributeType.shouldUseAXNUIComponents ? (
                                    <SelfServicePrefilledAttributeAxnuiComponent
                                        attributeTypesWithField={attributeType}
                                        attributeFieldValues={attributeTypeToFieldValueMap[attributeType.attributeType.id]}
                                        attributeRequired={isStringTrue(attributeType.requiredForSelfServiceVerification)}
                                        validationErrors={validationErrors}
                                        onAttributeFieldChange={onAttributeFieldChange} />
                                ) :
                                    <>
                                        {attributeType.fields.map((attributeField, attributeFieldIndex) => (
                                            <SelfServicePrefilledAttributeTypeField
                                                key={attributeFieldIndex}
                                                attributeRequired={isStringTrue(attributeType.requiredForSelfServiceVerification)}
                                                attributeTemplateName={attributeType.templateName}
                                                attributeField={attributeField}
                                                attributeFieldValue={attributeTypeToFieldValueMap[attributeField.attributeTypeID]?.[attributeField.id]}
                                                attributeTypeFieldValueMap={attributeTypeToFieldValueMap[attributeField.attributeTypeID]}
                                                requestInProgress={requestInProgress}
                                                validationErrors={validationErrors[attributeField.attributeTypeID]?.[attributeField.id]}
                                                onAttributeFieldChange={handleAttributeFieldChange}
                                            />
                                        ))}
                                    </>
                                }
                            </div></div>
                    ))}
                </Accordion.Body>
            </Accordion.Item>
        </Accordion >
    );
};